var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"auth-popup-link",class:_vm.classes,attrs:{"data-toggle":"modal"},domProps:{"textContent":_vm._s(_vm.linkText)},on:{"click":_vm.showAuthPopup}})}
var staticRenderFns = []

export { render, staticRenderFns }